import React, { useEffect, useState } from 'react';
import styles from "./Sidebar.module.css";
import { useLocation, useNavigate } from 'react-router-dom';
import {  NEW_DAILOG, SAVED_CHATS, SETTINGS, WORKSAPCE, USAGE } from '../../Constants';
import { ReactComponent as Dashboard } from "./../../../Assets/svgs/dashboard.svg";
import { ReactComponent as Newchat } from "./../../../Assets/svgs/ai-chip-14066.svg";
import { ReactComponent as Savechats } from "./../../../Assets/svgs/savechats.svg";
import { ReactComponent as Settings } from "./../../../Assets/svgs/settings.svg";
import { ReactComponent as DashboardSelected } from "./../../../Assets/svgs/dashboardSelected.svg";
import { ReactComponent as NewchatSelected } from "./../../../Assets/svgs/ai-chip-active.svg";
import { ReactComponent as SavechatsSelected } from "./../../../Assets/svgs/savechatsSelected.svg";
import { ReactComponent as CloseSidebar } from "./../../../Assets/svgs/closeSidebar.svg";
import { callLogEvent } from '../../Util';
import { ReactComponent as UsageActive } from "./../../../Assets/svgs/usage-active.svg";
import { ReactComponent as UsageInactive } from "./../../../Assets/svgs/usage-unactive.svg";

export interface PageItem {
    Title: string;
    isActive: boolean;
    url: string;
    Icon?: any;
    activeIcon?: any;
    disableIcon?: string;
    showSubItems?: boolean;
    isDisable?: boolean;
    userAccess?: string[];
}
interface SidebarProps {
  handleRecentQueries?: () => void;
  isExpandedHeader?: boolean;
}

export const pageItems: PageItem[] = [
    {
        Title: "Close",
        isActive: false,
        url: "",
        Icon: <CloseSidebar height={'18px'} width={'18px'} />,
        activeIcon: <CloseSidebar height={'18px'} width={'18px'} />,
        isDisable: false
    },
    {
        Title: "New dailog",
        isActive: false,
        url: NEW_DAILOG,
        Icon: <Newchat height={'18px'} width={'18px'} />,
        activeIcon: <NewchatSelected height={'18px'} width={'18px'} />,
        isDisable: false
    },
    {
        Title: "Work Space",
        isActive: false,
        url: WORKSAPCE,
        Icon: <Dashboard height={'18px'} width={'18px'} />,
        activeIcon: <DashboardSelected height={'18px'} width={'18px'} />,
        isDisable: false
    },
    {
        Title: "Saved Chats",
        isActive: false,
        url: SAVED_CHATS,
        Icon: <Savechats height={'18px'} width={'18px'} />,
        activeIcon: <SavechatsSelected height={'18px'} width={'18px'} />,
        isDisable: false
    },
    {
        Title: "Settings",
        isActive: false,
        url: SETTINGS,
        Icon: <Settings height={'18px'} width={'18px'} />,
        activeIcon: <Settings height={'18px'} width={'18px'} />,
        isDisable: false
    },
    {
    Title: "Recent Queries",
    isActive: false,
    url: "#recent-queries", 
    Icon: <Savechats height={"18px"} width={"18px"} />,
    activeIcon: <SavechatsSelected height={"18px"} width={"18px"} />,
    isDisable: false,
  }
];
const Sidebar = ({ handleRecentQueries, isExpandedHeader }: SidebarProps) => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const [pageDetails, setPagedetails] = useState<PageItem[]>(pageItems!);
  const location = useLocation();
  const dataSource = (localStorage.getItem("DataSource") || "").toLowerCase();
  const isMiddleEastMt = dataSource === "uae_mt" || dataSource === "ksa_mt";

    const navigateTo = (url: string, isNavigate = true) => {
        const latestPageDetails: PageItem[] = [...pageDetails];
        latestPageDetails.map((page) => {
            page.isActive = false;
            if (page.url === url) {
                page.isActive = true;
                return page;
            }
        })
        setPagedetails(latestPageDetails);
        if (isNavigate) {
            navigate(url);
        }
    }

  useEffect(() => {
    navigateTo(location.pathname, true);
  }, [location.pathname]);

  if (isMiddleEastMt) {
    return null;
  }

  return (
    <div
      className={`${styles.sidebar} ${isHovered ? styles.expanded : ""}`}
      style={isExpandedHeader ? { display: "none" } : { top: "43px" }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {pageDetails &&
        pageDetails.map((page, pageIndex) => {
          return (
            <div
              key={pageIndex}
              className={`${styles.sidebarItem} ${
                page.isActive ? styles.sidebarItemActive : ""
              }`}
              onMouseDown={(event) => {
                callLogEvent(
                  "CLICKED_ON_SIDEBAR_PAGE_NAVIGATION_" +
                    page.Title.trim().toUpperCase().replaceAll(" ", "_"),
                  "Clicked to navigate to " +
                    page.Title.trim().toUpperCase().replaceAll(" ", "_")
                );

                if (page.Title === "Recent Queries") {
				          event.stopPropagation(); 
                            handleRecentQueries?.();
                } else {
                  navigateTo(page.url);
                }
              }}
                    hidden={pageIndex === 0}>
                    <span >{page.isActive ? page.activeIcon : page.Icon} {isHovered ? <span className='f14px'>{page.Title}</span> : ""}</span>

                </div>
          );
            })}
        </div>
    );
};

export default Sidebar;
